import * as React from 'react';
import './termsOfServicePane.module.scss';

type Props = {
    content: string;
};

export const TermsOfServiceText = ({ content }: Props) => (
    <div styleName="terms-of-service">
        <div styleName="header">利用規約</div>
        <div styleName="lead-text">
            本利用規約(以下「本規約」といいます。)は、当社と申込者及び利用者との間の権利義務関係が定められています。本サービスの利用に際しては、本規約の全文をお読みいただいたうえで、本規約に同意いただく必要があります。
        </div>
        <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
);

export const TermsOfServicePane = ({ content }: Props) => {
    return (
        <div styleName="terms-wrapper">
            <div styleName="terms-header">利用規約</div>
            <div styleName="lead-text">下記の利用規約をよく読んでいただき同意の上お申し込みにお進みください</div>
            <TermsOfServiceText content={content} />
        </div>
    );
};
